// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card___KEJ4y{--perxis-auto-car-card-padding-top-inner: var(--perxis-auto-car-card-padding-top, var(--perxis-auto-gap-vertical-yellow-inner));--perxis-auto-car-card-padding-bottom-inner: var(--perxis-auto-car-card-padding-bottom, var(--perxis-auto-gap-vertical-red-inner));--perxis-auto-header-border-width: 0;padding-top:var(--perxis-auto-car-card-padding-top-inner);padding-bottom:var(--perxis-auto-car-card-padding-bottom-inner);min-height:400px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card___KEJ4y`
};
export default ___CSS_LOADER_EXPORT___;
